import React from 'react';
import { Modal, Button } from 'antd';
import { navigate } from 'gatsby';

interface TokenExpiredModalProps {
  open: boolean;
  onClose: () => void;
}

const TokenExpiredModal: React.FC<TokenExpiredModalProps> = ({ open, onClose }) => {
  const handleWhatsAppRedirect = () => {
    onClose(); // This should handle the WhatsApp redirect
  };

  const handleModalClose = () => {
    onClose();
    // Navigate to 401 page only when closing the modal (not when clicking the button)
    navigate('/401');
  };

  return (
    <Modal
      open={open}
      onCancel={handleModalClose}
      footer={[
        <Button key="close" type="primary" onClick={handleWhatsAppRedirect}>
          Escribirle al bot de WhatsApp
        </Button>
      ]}
      centered
      title="Sesión expirada por seguridad"
      maskClosable={false}
      closable={false}
    >
      <p>
        Por razones de seguridad, tu sesión ha expirado.<br/>
        Por favor, vuelve a escribirle al bot de WhatsApp para obtener un nuevo enlace y finalizar tu transferencia.
      </p>
      <p>
        Hacemos esto para protegerte y asegurar que tus transacciones sean seguras.
      </p>
    </Modal>
  );
};

export default TokenExpiredModal; 